// extracted by mini-css-extract-plugin
module.exports = {"inputBox":"InputSearch_inputBox__1t2Lk"};